var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_028-sphere",
    "data-name": "028-sphere",
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M54,30A24,24,0,1,0,78,54,24.027,24.027,0,0,0,54,30ZM33.2,54A20.828,20.828,0,0,1,52.4,33.261V45.137a1.6,1.6,0,0,0,3.2,0V33.423C60.946,34.916,65.2,43.732,65.2,54s-4.254,19.084-9.6,20.577V62.589a1.6,1.6,0,0,0-3.2,0v12.15A20.828,20.828,0,0,1,33.2,54ZM63.1,72.7a21.109,21.109,0,0,0,1.344-2.07A34.084,34.084,0,0,0,68.4,54a34.084,34.084,0,0,0-3.96-16.633A21.11,21.11,0,0,0,63.1,35.3a20.8,20.8,0,0,1,0,37.406Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M111.6,121.2a9.6,9.6,0,1,1,9.6-9.6A9.611,9.611,0,0,1,111.6,121.2Zm0-16a6.4,6.4,0,1,0,6.4,6.4A6.407,6.407,0,0,0,111.6,105.2Z",
    transform: "translate(-57.6 -57.6)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature_2.3713b1c11c191668042dac7a492a7ef2.svg";
export { ForwardRef as ReactComponent };